<!--//@*/*
    //    *BCS   App v0.91
    //    * Copyright (c) 2025, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->
<template>
  <!-- attachment and Form -->
  <v-container id="nibrs_review_form" class="mt-13">
    <!-- attachment -->

    <div id="full" class="full-form">
      <v-form id="full_form" ref="formIn">
        <v-container>
          <v-row>
            <v-col cols="12" md="12" lg="12">
              <!-- checkbox -->
              <v-checkbox
                id="checkbox"
                v-model="formIn.agree"
                required
                :color="isChecked ? 'grey' : 'greenbtn'"
                label="By checking this box, I hereby acknowledge that I have received, read, and understand the contents of the NIBRS Training PowerPoint. I understand that it is my responsibility to comply with the policies, procedures, and guidelines outlined in this manual, and to seek clarification from my supervisor or manager if I have any questions or need further explanation.
          Executed at Reno, Washoe County, Nevada, on this day."
              >
              </v-checkbox>
              <v-text-field
                color="greenbtn"
                id="date"
                v-model="formIn.submit_date"
                label="Date"
                required
                v-mask="'##/##/####'"
                :rules="Daterules"
              >
              </v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" lg="12">
              <v-text-field
                color="greenbtn"
                id="email"
                v-model="formIn.email"
                name="email"
                maxlength="60"
                label="Email"
                ref="email"
                :rules="emailRules"
                counter="60"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- button row -->
          <v-row class="btn-row">
            <v-col>
              <div
                class="submit-btn mt-3 d-flex justify-space-between align-center"
              >
                <v-btn dark class="mb-2 mr-3 greenbtn black--text" @click="save"
                  >submit</v-btn
                >
                <v-btn dark class="mb-2 greenbtn black--text" @click="reset"
                  >Reset</v-btn
                >
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-form>

      <div class="bottom-space"></div>
    </div>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .header p {
    font-size: 1.2em;
    font-weight: 400;
  }

  .sub-header p,
  .sub-header ol {
    font-size: 1em;
    font-weight: 300;
  }

  .full-form,
  #full_form {
    width: 100%;
  }

  #checkbox {
    color: white;
  }

  .btn-row {
    width: 80%;
    margin: 0 auto;
  }
}

/* 768 media q */
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
export default {
  name: "nibrs_review_form",
  mixins: [bus_common],
  data() {
    return {
      reqRules: [(v) => !!v || "Field is required"],
      Daterules: [(value) => this.date_is_valid(value) || "Invalid date."],
      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
      isChecked: false,
      formIn_new: {
        submit_date: "",
        email: "",

        agree: false,
      },
      formIn_dev: {
        submit_date: "04/08/2025",
        email: "my@email.com",

        agree: false,
      },
      formIn: {
        submit_date: "",
        email: "",

        agree: false,
      },
    };
  },
  methods: {
    save() {
      console.log("save");
      //validate
      if (this.formIn.agree == false) {
        this.swall_it(
          "Submit Status",
          "Before continuing, you must check the box at the top of the form and agree to its conditions.",
          "warning",
          null,
          null
        );
        return true;
      }
      if (this.$refs.formIn.validate() == false) {
        this.swall_it(
          "Submit Status",
          "Your form has errors. Please address the red fields.",
          "warning",
          null,
          null
        );
        return true;
      }

      this.show_loader(true);
      let form_nibrs = {};
      form_nibrs = this.mno(this.formIn);
      form_nibrs.submit_date = this.format_date_sql(form_nibrs.submit_date);

      form_nibrs.apiname = "save";

      let self = this;
      this.$store
        .dispatch("anyapi", form_nibrs)
        .then((data) => {
          this.show_loader(false);
          this.mrbreakpoint("save");
          if (data.msg == "Email not found.") {
            this.swall_it(
              "Submit Status",
              "This email is not found. Check email spelling?",
              "warning",
              null,
              null
            );
            return true;
          } else {
            self.$refs.formIn.reset();
            setTimeout(() => {
              self.formIn.submit_date = self.format_date_us(new Date());
            }, 500);

            this.swall_it(
              "Submit Status",
              "Success. You may now close this window.",
              "success",
              null,
              null
            );
            return true;
          }
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Saving", msg, "error", null, null);
        });
    },
    reset() {
      this.$refs.formIn.reset();
    },
    message1() {
      alert("This button does nothing yet.");
    },
    message2() {
      alert("This button also does nothing yet.");
    },
    init() {
      this.formIn = this.mno(this.formIn_new);
      this.formIn.submit_date = this.format_date_us(new Date());
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
